import React, { useCallback, useMemo } from "react";

import InvestorMetricGrid from "./InvestorMetricGrid";
import InvestorPortfolioVisualization from "./InvestorPortfolioVisualization";
import { buildPortfolioSummaryMetrics } from "../../utils/investorPortfolioMetrics";

/**
 * My Portfolio — summary metrics + holdings (Shares Management / history / dashboard).
 */
export default function MyPortfolioSection({
  holdings = [],
  redemptionBalances = [],
  formatShare,
  formatMoney,
  moneyValue,
  lifecyclePillClass,
  hidePieChart = true,
  showMetrics = true,
}) {
  const holdingsWithShares = useMemo(
    () => holdings.filter((h) => Number(h.shares_held) > 0),
    [holdings]
  );

  const amountFmt = useMemo(
    () => new Intl.NumberFormat("en-BD", { maximumFractionDigits: 2, minimumFractionDigits: 0 }),
    []
  );
  const fallbackMoneyValue = useCallback(
    (amount, sign = "") => ({
      type: "money",
      sign,
      amount: amountFmt.format(amount),
    }),
    [amountFmt]
  );
  const toMoneyValue = moneyValue || fallbackMoneyValue;

  const portfolioMetrics = useMemo(
    () =>
      showMetrics
        ? buildPortfolioSummaryMetrics({
            holdings,
            redemptionBalances,
            moneyValue: toMoneyValue,
            formatShare,
          })
        : [],
    [showMetrics, holdings, redemptionBalances, toMoneyValue, formatShare]
  );

  return (
    <section className="investor-section invx-shares-holdings-section" aria-label="My portfolio">
      {showMetrics && portfolioMetrics.length ? <InvestorMetricGrid metrics={portfolioMetrics} /> : null}
      <InvestorPortfolioVisualization
        holdings={holdingsWithShares}
        redemptionBalances={redemptionBalances}
        formatShare={formatShare}
        formatMoney={formatMoney}
        lifecyclePillClass={lifecyclePillClass}
        hidePieChart={hidePieChart}
      />
    </section>
  );
}
